import { actionIndicatorToIcon } from './ActionIndicator.js';
import styles from './Button.module.scss.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { UNSAFE_Icon } from '../icon/Icon.js';
import { DsxLoadingSpinner } from '../icon/icons/loading-spinner.js';
import classNames from 'clsx';

const buttonSizeToIconSize = {
  'small-compact': '20px',
  small: '20px',
  compact: '24px',
  default: '24px',
  large: '28px',
  xl: '32px'
};
function ButtonContent(props) {
  const {
    children,
    icon,
    iconOnly,
    size = 'default',
    actionIndicator,
    loadingState
  } = props;
  const contentEl = iconOnly ? null : /*#__PURE__*/jsx("span", {
    className: styles['content'],
    children: children
  });
  const iconSize = buttonSizeToIconSize[size];
  const iconStart = !icon ? null : /*#__PURE__*/jsx("span", {
    className: styles['icon'],
    children: /*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: icon,
      size: iconSize
    })
  });
  const iconEnd = !actionIndicator ? null : /*#__PURE__*/jsx("span", {
    className: styles['icon'],
    children: /*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: actionIndicatorToIcon[actionIndicator],
      size: iconSize
    })
  });
  let childEl = /*#__PURE__*/jsxs(Fragment, {
    children: [iconStart, contentEl, iconEnd]
  });
  if (loadingState === 'loading') {
    childEl = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("span", {
        className: styles['hidden-contents'],
        children: childEl
      }), /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: DsxLoadingSpinner,
        className: classNames(styles['spinner'], styles['icon']),
        size: iconSize
      })]
    });
  }
  return childEl;
}

export { ButtonContent, buttonSizeToIconSize };
